import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";

import { AuthRouter } from "@/features/auth/AuthRouter";
import { RoleRouter } from "@/features/role/RoleRouter";
import { UserRouter } from "@/features/user/UserRouter";
import { PermissionRouter } from "@/features/permission/PermissionRouter";
import { PromotionRouter } from "@/features/promotion/PromotionRouter";
import { MigrateRouter } from "@/features/migrate/MigrateRouter";
import { OrderRouter } from "@/features/order/OrderRouter";
import { FixOrderRouter } from "@/features/fix-order/FixOrderRouter";
import { ShopRouter } from "@/features/shop/ShopRouter";
import { ShopifyRouter } from "@/features/shopify/ShopifyRouter";
import { MarketplaceRouter } from "@/features/marketplace/MarketplaceRouter";
import { ErrorTrackingRouter } from "@/features/error-trackings/ErrorTrackingRouter";
import { DeliveryModeRouter } from "@/features/delivery-modes/DeliveryModeRouter";
import { ShipnityRouter } from "@/features/shipnity/ShipnityRouter";
import { LineRouter } from "@/features/line/LineRouter";
import { BridgeSystemRouter } from "@/features/bridge-system/BridgeSystemRouter";
import { ShippopRouter } from "@/features/shippop/ShippopRouter";
import { TMSRouter } from "@/features/tms-shop-register/TMSRouter";
import { ErrorEventRouter } from "@/features/notification/ErrorEventRouter";

// import NotFoundPage from "@/common/components/NotFoundPage.vue";

Vue.use(VueRouter);

const loginGuard = (next: any): boolean => {
  const hasAccessToken = Vue.prototype.$dep.httpClient.hasAccessToken();

  if (!hasAccessToken) {
    next({ name: "AuthLoginPage" });
  }

  return !hasAccessToken;
};

const routes: Array<RouteConfig> = [
  { path: "/auth", component: AuthLayout, children: [...AuthRouter()] },
  {
    path: "/",
    component: AppLayout,
    children: [
      ...PermissionRouter(),
      ...PromotionRouter(),
      ...MigrateRouter(),
      ...RoleRouter(),
      ...UserRouter(),
      ...OrderRouter(),
      ...FixOrderRouter(),
      ...ShopRouter(),
      ...ShopifyRouter(),
      ...MarketplaceRouter(),
      ...ErrorTrackingRouter(),
      ...DeliveryModeRouter(),
      ...ShipnityRouter(),
      ...LineRouter(),
      ...BridgeSystemRouter(),
      ...ShippopRouter(),
      ...TMSRouter(),
      ...ErrorEventRouter()
    ],
    beforeEnter: (to, from, next) => {
      if (loginGuard(next)) return;
      next();
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
